<div class="filter filter-property full-span" [class.disabled]="!override.displayOptions.active">
  <span class="input-group-btn">
    <button class="btn toggle-btn" [class.off]="!override.displayOptions.active" (click)="toggle()"></button>
  </span>
  <span class="filter-body">
    <span filter-title [text]="override.name ?? (exampleName + (isMobile() ? 's' : ' Overrides'))">
      {{ descriptionText || ('This allows you to override the default label style & Minimap Icon for all ' + exampleName + 's.') }}
    </span>
    <span class="sep"></span>
    <div class="filter-title filter-label table-checkbox-group">
      <span class="input-group-btn">
        <button class="btn toggle-btn" [disabled]="!override.displayOptions.active"
          [class.off]="!override.displayOptions.cosmeticOptions?.minimapIconShape"
          (click)="toggleMinimapIconShape()"></button>
      </span>
      <span class="table-checkbox-label">Map Icon</span>
    </div>
    <span class="sep"></span>
    <app-select-minimap-icon
      [(ngModel)]="override.displayOptions.cosmeticOptions!.minimapIconShape"
      (selectedValueChange)="updateFilter()"
      [disabled]="!override.displayOptions.active || !override.displayOptions.cosmeticOptions?.minimapIconShape">
    </app-select-minimap-icon>
    <span class="sep"></span>
    <button class="btn toggle-button" style="padding: 0px !important;" [disabled]="!override.displayOptions.active"
      (click)="cosmeticControls.labelOptionsOpen = !cosmeticControls.labelOptionsOpen">
      <div app-label-viewer
        [rarity]="rarity"
        [isCurrency]="isCurrency"
        [isWaystone]="isWaystone"
        [isPoe1Gem]="isPoe1Gem"
        [displayOptions]="override.displayOptions"
        [exampleName]="exampleName"
        [dirtyForceUpdate]="dirtyForceUpdate"
        [clickable]="true"></div>
    </button>
  </span>
</div>

<app-cosmetic-settings style="display: table;"
  [cosmeticOptions]="override.displayOptions.cosmeticOptions!"
  [cosmeticControls]="cosmeticControls"
  [active]="override.displayOptions.active ?? true"
  filterClasses="filter-padded"
  (updateFilter)=" dirtyForceUpdate = dirtyForceUpdate + 1; updateFilter()"
>
</app-cosmetic-settings>

